import { memo } from 'react'
import { DgtPdOrderPicklistMovement } from '../models'
import { EditorProps } from 'react-data-grid'
import Modal from './Modal'
import { formatDateFromUnix, formatNumberV2 } from '../utilities/Format'

const WasteConfirmEditor = memo(({ props, isApprove } : {
  props: EditorProps<DgtPdOrderPicklistMovement>, isApprove: boolean
}) => {
  const { onClose, onRowChange, row } = props

  return isApprove ? <Modal show={true} onHide={onClose}
    okTheme='success'
    okText='อนุมัติ'
    okAction={() => {
      const updatedRow = { ...row,
        approvedWasteReturnDateTime: Math.floor(Date.now() / 1000)
      }
      onRowChange(updatedRow, true)
    }}
    cancelText='ปิด'
    title={`${row.materialCode} - ${row.materialDescription}`}
    >
    <>
    <div className='grid grid-cols-2 mb-3'>
      <h6>PD ORDER#</h6>
      <h6 className='font-bold '>{row.orderId}</h6>
      <h6>ยอดคืนเสีย</h6>
      <h6 className='font-bold text-red-500 '>{formatNumberV2(row.returnWasteQty)} {row.materialUnit}</h6>
      <h6>Batch Lot</h6>
      <h6 className='font-bold '>{row.batchLotNo}</h6>
      <h6>บันทึกเมื่อ</h6>
      <h6 className='font-bold '>{formatDateFromUnix(row.recordedDateTime)}</h6>
    </div>
    <h6>ยืนยันที่จะอนุมัติยอดคืนเสืย หรือไม่ ?</h6>
    </>
  </Modal> : <Modal show={true} onHide={onClose}
    okTheme='danger'
    okText='ปฏิเสธ'
    okAction={() => {
      let updatedRow = { ...row }
      delete updatedRow.approvedWasteReturnDateTime
      onRowChange(updatedRow, true)
    }}
    cancelText='ปิด'
    title={`กำลังปฏิเสธนับ ${row.materialCode} - ${row.materialDescription}`}
    >
    <h6>ยืนยันปฏิเสธใช่หรือไม่ ?</h6>
  </Modal>
})

export default memo(WasteConfirmEditor)